import React, { useEffect, useState } from "react";
import { getAllEmployees } from "../../../../api/hrDashboard";

// ✅ ICONS
import { HiUserGroup } from "react-icons/hi";
import { MdOutlineWork } from "react-icons/md";
import { FaRegCalendarAlt } from "react-icons/fa";
import { IoStarOutline } from "react-icons/io5";
import { AiOutlineWarning } from "react-icons/ai";

// ✅ CARD CONFIG
const CARDS = [
  {
    label: "TOTAL EMPLOYEES",
    icon: <HiUserGroup color="#9FB8E8" size={20} />,
    key: "total",
    trend: "+12",
    trendUp: true,
    borderColor: "#2E5CB8",
    bg: "#E8EFFA",
  },
  {
    label: "PRESENT TODAY",
    icon: <MdOutlineWork color="#9FB8E8" size={20} />,
    key: "present",
    trend: "86%",
    trendUp: true,
    borderColor: "#2E5CB8",
    bg: "#E8EFFA",
  },
  {
    label: "ON LEAVE",
    icon: <FaRegCalendarAlt color="#FCD34D" size={18} />,
    key: "onLeave",
    trend: "+8",
    trendUp: true,
    borderColor: "#f59e0b",
    bg: "#FEF3C7",
  },
  {
    label: "NEW HIRES",
    icon: <IoStarOutline color="#86EFAC" size={20} />,
    key: "newHires",
    trend: "+15%",
    trendUp: true,
    borderColor: "#22c55e",
    bg: "#DCFCE7",
  },
  {
    label: "ATTRITION RISK",
    icon: <AiOutlineWarning color="#FCA5A5" size={20} />,
    key: "attrition",
    trend: "-4",
    trendUp: false,
    borderColor: "#ef4444",
    bg: "#FEE2E2",
  },
];

const TopCards = () => {
  const [stats, setStats] = useState({
    total: "--",
    present: "--",
    onLeave: "--",
    newHires: "--",
    attrition: "--",
  });

  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAllEmployees()
      .then((res) => {
        const employees = res.data || [];

        const today = new Date();
        const thirtyDaysAgo = new Date();
        thirtyDaysAgo.setDate(today.getDate() - 30);

        const active = employees.filter((e) => !e.deboardEmp);
        const deboarded = employees.filter((e) => e.deboardEmp);

        const newHires = active.filter(
          (e) =>
            e.dateOfJoining &&
            new Date(e.dateOfJoining) >= thirtyDaysAgo
        );

        setStats({
          total: active.length,
          present: active.length, 
          onLeave: "--",
          newHires: newHires.length,
          attrition: deboarded.length,
        });
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  return (
    <>
      <style>{`
        .tc-row {
          display: flex;
          gap: 15px;
          width: 100%;
        }

        .tc-card {
          flex: 1;
          min-width: 0;
          background: #ffffff;
          border: 1px solid #e5e7eb;
          border-radius: 12px;
          padding: 14px 16px 16px;
          transition: all 0.2s ease;
        }

        .tc-card:hover {
          transform: translateY(-3px);
          box-shadow: 0 6px 18px rgba(0,0,0,0.08);
        }

        .tc-top {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 10px;
        }

        .tc-icon {
          width: 34px;
          height: 34px;
          border-radius: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .tc-trend {
          font-size: 11px;
          font-weight: 600;
          display: flex;
          align-items: center;
          gap: 2px;
        }

        .tc-value {
          font-size: 28px;
          font-weight: 700;
          color: #1e293b;
          line-height: 1;
          margin-bottom: 6px;
        }

        .tc-label {
          font-size: 10px;
          color: #9ca3af;
          font-weight: 600;
          letter-spacing: 0.06em;
        }

        /* Responsive Changes */
        @media (max-width: 1024px) {
          .tc-row {
            display: grid;
            grid-template-columns: 1fr 1fr; /* 2 cards per row on tablets */
          }
        }

        @media (max-width: 600px) {
          .tc-row {
            display: grid;
            grid-template-columns: 1fr; /* 🔥 1 card per row on mobile */
          }
        }
      `}</style>

      <div className="tc-row">
        {CARDS.map((c) => (
          <div
            key={c.key}
            className="tc-card"
            style={{ borderTop: `3px solid ${c.borderColor}` }}
          >
            <div className="tc-top">
              <span
                className="tc-icon"
                style={{ background: c.bg }}
              >
                {c.icon}
              </span>

              <span
                className="tc-trend"
                style={{
                  color: c.trendUp ? "#22c55e" : "#ef4444",
                }}
              >
                {c.trendUp ? "↑" : "↓"} {c.trend}
              </span>
            </div>

            <div className="tc-value">
              {loading ? (
                <span style={{ color: "#d1d5db", fontSize: 16 }}>
                  ...
                </span>
              ) : (
                stats[c.key]
              )}
            </div>

            <div className="tc-label">{c.label}</div>
          </div>
        ))}
      </div>
    </>
  );
};

export default TopCards;